<template>
  <div>
    <!-- 发展历程 -->
    <div class="DevelopmentHistory">
      <div class="History_swiper_box">
        <swiper
          :options="swiperOptionH"
          ref="mySwiper1"
          class="swiper-container"
        >
          <swiper-slide v-for="(item, index) in historyArr" :key="index">
            <div class="item_slide">
              <div class="left_box">
                <div class="writing_death_box">
                  <div class="en">HISTORY</div>
                  <div class="zh">发展历程</div>
                  <div class="line"></div>
                </div>
                <div class="dynamic_box">
                  <div class="year">{{ item.year }}</div>
                  <div class="child_box">
                    <div
                      class="child_item_time"
                      v-for="(i, k) in item.content"
                      :key="k"
                    >
                      {{ i.info }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="right_box">
                <img :src="item.image" class="img_cover" alt="" />
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="control_box">
        <div class="prev_next_box">
          <img
            :src="prev_img"
            class="prev_History"
            alt=""
            @mouseenter="prevEnter"
            @mouseleave="prevLeave"
          />
          <img
            :src="next_img"
            class="next_History"
            alt=""
            @mouseenter="nextEnter"
            @mouseleave="nextLeave"
          />
        </div>
        <!-- <div class="pagi_box">
          <div class="swiper-pagination" slot="pagination"></div>
        </div> -->
        <div class="min_swiper">
          <swiper
            style="width: 100%; height: 100%"
            :options="swiperOptionMin"
            ref="mySwiper"
            class="swiper-container"
          >
            <swiper-slide v-for="(item, index) in historyArr" :key="index">
              <div class="min_text" @click="selectSwipermin(index)">
                {{ item.year }}
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCourse } from "../../http/api";
export default {
  name: "",
  props: {},
  components: {},
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    swiper1() {
      return this.$refs.mySwiper1.swiper;
    },
  },
  data() {
    var that = this;
    return {
      prev_img: require("../../assets/indexImg/transparent_prev_img.png"),
      next_img: require("../../assets/indexImg/transparent_next_img.png"),
      active_Index: 0,
      centeredSlides: false,
      swiperOptionMin: {
        slidesPerView: 7,
        centeredSlides: that.centeredSlides,
        slideToClickedSlide: true,
        on: {
          slideChangeTransitionStart: function () {
            that.swiper1.slideTo(this.activeIndex, 1000, false);
            that.active_Index = this.activeIndex;
          },
        },
      },
      swiperOptionH: {
        slidesPerView: 1,
        navigation: {
          nextEl: ".next_History",
          prevEl: ".prev_History",
        },
        effect: "cube",
        on: {
          slideChangeTransitionStart: function () {
            that.active_Index = this.activeIndex;
            that.swiper.slideTo(that.active_Index, 1000, false);
            $(
              $(".min_swiper .swiper-container .swiper-wrapper .swiper-slide")
            ).removeClass("swiper-slide-active");
            $(
              $(".min_swiper .swiper-container .swiper-wrapper .swiper-slide")[
                that.active_Index
              ]
            ).addClass("swiper-slide-active");
          },
        },
        pagination: {
          //分页容器的css选择器
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      historyArr: [],
    };
  },
  methods: {
    selectSwipermin(index) {
      $(
        $(".min_swiper .swiper-container .swiper-wrapper .swiper-slide")
      ).removeClass("swiper-slide-active");
      this.swiper1.slideTo(index, 1000, false);
      $(
        $(".min_swiper .swiper-container .swiper-wrapper .swiper-slide")[index]
      ).addClass("swiper-slide-active");
    },
    prevLeave() {
      this.prev_img = require("../../assets/indexImg/transparent_prev_img.png");
    },
    prevEnter() {
      this.prev_img = require("../../assets/indexImg/blue_prev_img.png");
    },
    nextLeave() {
      this.next_img = require("../../assets/indexImg/transparent_next_img.png");
    },
    nextEnter() {
      this.next_img = require("../../assets/indexImg/blue_next_img.png");
    },
    getdata() {
      getCourse().then((res) => {
        // if (res.status === "SUCCESS") {
        this.historyArr = res.data;
        console.log(this.historyArr);
        // }
      });
    },
  },
  mounted() {
    this.getdata();
  },
};
</script>

<style scoped lang='scss'>
.DevelopmentHistory {
  width: 1214px;
  // height: 458px;
  height: 45.8vh;
  margin: 0 auto;
  // margin-top: 80px;
  margin-top: 8vh;
  .History_swiper_box {
    width: 100%;
    height: 100%;
    .item_slide {
      width: 100%;
      // height: 458px;
      height: 45.8vh;
      display: flex;
      justify-content: space-between;
      .left_box {
        width: 418px;
        // height: 458px;
        height: 45.8vh;
        .writing_death_box {
          .en {
            font-size: 46px;
            font-family: Arial;
            font-weight: 400;
            // line-height: 52px;
            line-height: 5.2vh;
            color: #0fffff;
          }
          .zh {
            font-size: 46px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            // line-height: 61px;
            line-height: 6.1vh;
            color: #0fffff;
          }
          .line {
            width: 260px;
            height: 2px;
            background: #0fffff;
            // margin-top: 20px;
            margin-top: 2vh;
          }
        }
        .dynamic_box {
          width: 100%;
          // margin-top: 37px;
          margin-top: 3.7vh;
          .year {
            font-size: 46px;
            font-family: DIN;
            font-weight: bold;
            // line-height: 62px;
            line-height: 6.2vh;
            color: #ffffff;
          }
          .child_box {
            // height: 217px;
            height: 23vh;
            width: 100%;
            // margin-top: 7px;
            margin-top: 0.7vh;
            overflow-y: auto;
            .child_item_time {
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              // line-height: 24px;
              /* line-height: 3.4vh; */
              line-height: 30px;
              color: #ffffff;
              // margin-bottom: 20px;
              margin-bottom: 2vh;
            }
          }
          .child_box::-webkit-scrollbar {
            display: none;
          }
        }
      }
      .right_box {
        width: 750px;
        // height: 458px;
        height: 45.8vh;
      }
    }
  }
  .control_box {
    width: 100%;
    // height: 120px;
    height: 12vh;
    display: flex;
    // margin-top: 60px;
    margin-top: 6vh;
    justify-content: space-between;
    align-items: center;
    .prev_next_box {
      width: 212px;
      // height: 92px;
      height: 92px;
      display: flex;
      justify-content: space-between;
      .prev_History {
        width: 92px;
        height: 92px;
      }
      .next_History {
        width: 92px;
        height: 92px;
      }
      .prev_History:focus,
      .next_History:focus {
        outline: none;
      }
    }
    .min_swiper {
      width: 750px;

      height: 100%;
      .min_text {
        padding-left: 10px;
        padding-right: 42px;
        height: 100%;
        border-left: 1px solid #c8c8c8;
        text-align: center;
        line-height: 120px;
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #c8c8c8;
        transition: all 0.5s;
      }
    }
    .pagi_box {
      width: 750px;
      height: 100%;
      .swiper-pagination {
        .swiper-pagination-bullet {
          margin-left: 20px !important;
        }
      }
    }

    // .pagi_box > div::-webkit-scrollbar {
    //   display: none !important;
    // }
    // .pagi_box > div::-ms-scrollbar {
    //   display: none !important;
    // }

    // .pagi_box > div::-moz-scrollbar {
    //   display: none !important;
    // }
    // .pagi_box > div::-o-scrollbar {
    //   display: none !important;
    // }
  }
}
</style>